<div class="sig-main-div">
	<div
		class="sig-input-view-container mr-[10px] ml-[0px]"
		style="display: flex; flex-wrap: wrap; gap: 12px"
	>
		<lbca-entity-fields
			class="ttfc-field-size-4"
			label="Índice de Atualização"
			[forceType]="'SELECT_ONE'"
			[field]="fields.update_index"
			[value]="values.update_index"
			[labeled]="true"
			[disabled]="false"
			(focusState)="focusState($event, 'update_index')"
			(errorState)="setErrorState($event, 'update_index')"
			(validStatus)="setValidState($event, 'update_index')"
			(changeValue)="changeField($event, 'update_index')"
		></lbca-entity-fields>

		@if (values.update_index !== '/monetary-rate/no-apply') {
			<lbca-date-picker
				class="ttfc-field-size-4"
				[labeled]="true"
				label="Data de Referência"
				[require]="false"
				[disabled]="false"
				[value]="values.reference_date"
				(errorState)="setErrorState($event, 'reference_date')"
				(validStatus)="setValidState($event, 'reference_date')"
				(changeValue)="changeField($event, 'reference_date')"
			></lbca-date-picker>
		}

		<lbca-entity-fields
			class="ttfc-field-size-4"
			label="Tipo de Cambio"
			[forceType]="'SELECT_ONE'"
			[field]="fields.type_exchange_rate"
			[labeled]="true"
			[value]="values.type_exchange_rate"
			[disabled]="false"
			(focusState)="focusState($event, 'type_exchange_rate')"
			(errorState)="setErrorState($event, 'type_exchange_rate')"
			(validStatus)="setValidState($event, 'type_exchange_rate')"
			(changeValue)="changeField($event, 'type_exchange_rate')"
		></lbca-entity-fields>

		@if (values.type_exchange_rate !== 'noApply') {
			<lbca-input-text
				class="ttfc-field-size-4"
				label="Cotação do Dólar"
				[labeled]="true"
				[value]="values.dolar_quotation?.toFixed(2)"
				(valueChange)="values.dolar_quotation = toNumber($event)"
				[disabled]="values.type_exchange_rate !== '2'"
				maskInput="CURRENCY_BR"
				[loadingState]="loading_dolar_quotation"
				(focusState)="focusState($event, 'dolar_quotation')"
				(setError)="setErrorState($event, 'dolar_quotation')"
				(validStatus)="setValidState($event, 'dolar_quotation')"
				(changeValue)="changeField($event, 'dolar_quotation')"
			></lbca-input-text>
		}

		<lbca-input-text
			[disabled]="values.type_exchange_rate !== 'noApply'"
			class="ttfc-field-size-4"
			label="Valor"
			[labeled]="true"
			[value]="values.payValue?.toFixed(2)"
			(valueChange)="values.payValue = toNumber($event)"
			maskInput="CURRENCY_BR"
			(focusState)="focusState($event, 'payValue')"
			(setError)="setErrorState($event, 'payValue')"
			(validStatus)="setValidState($event, 'payValue')"
			(changeValue)="changeField($event, 'payValue')"
		></lbca-input-text>

		@if (values.type_exchange_rate !== 'noApply') {
			<lbca-input-text
				class="ttfc-field-size-4"
				label="Valor em Dólar"
				[labeled]="true"
				[value]="values.payValueUS?.toFixed(2)"
				(value)="values.payValueUS = toNumber($event)"
				maskInput="CURRENCY_US"
				(focusState)="focusState($event, 'payValueUS')"
				(setError)="setErrorState($event, 'payValueUS')"
				(validStatus)="setValidState($event, 'payValueUS')"
				(changeValue)="changeField($event, 'payValueUS')"
			></lbca-input-text>
		}

		<lbca-input-text
			class="ttfc-field-size-4"
			label="Valor Atualizado"
			[labeled]="true"
			[disabled]="true"
			[value]="values.updated_value"
			maskInput="CURRENCY_BR"
			[loadingState]="loading_updated_value"
			(focusState)="focusState($event, 'updated_value')"
			(setError)="setErrorState($event, 'updated_value')"
			(validStatus)="setValidState($event, 'updated_value')"
			(changeValue)="changeField($event, 'updated_value')"
		></lbca-input-text>

		@if (values.type_exchange_rate !== 'noApply') {
			<lbca-input-text
				class="ttfc-field-size-4"
				label="Valor Atualizado em Dólar"
				[labeled]="true"
				[disabled]="true"
				[value]="values.updated_value_us"
				maskInput="CURRENCY_US"
				[loadingState]="loading_updated_value_us"
				(focusState)="focusState($event, 'updated_value_us')"
				(setError)="setErrorState($event, 'updated_value_us')"
				(validStatus)="setValidState($event, 'updated_value_us')"
				(changeValue)="changeField($event, 'updated_value_us')"
			></lbca-input-text>
		}
	</div>
</div>
